<scs-navbar *ngIf="router.url != '/login' && afService.isLoggedIn"></scs-navbar>
<router-outlet></router-outlet>



// WEBPACK FOOTER //
// ./src/ng2/app/app.component.html